import { doNothing } from 'remeda';
import { ModalVariant } from 'src/components/ConfirmationModal/confirmation-modal';
import { create } from 'zustand';

type Resolver = (value: boolean) => void;

interface ConfirmationModalState {
  isOpen: boolean;
  title: string;
  body: string;
  variant: ModalVariant;
  openConfirmation: (
    title: string,
    body: string,
    variant: ModalVariant,
    onConfirm: Resolver,
  ) => void;
  closeConfirmation: () => void;
  returnConfirmationResult: (value: boolean) => void;
}

export const useConfirmationStore = create<ConfirmationModalState>((set) => ({
  isOpen: false,
  title: '',
  body: '',
  variant: 'normal',
  returnConfirmationResult: doNothing,

  // eslint-disable-next-line max-params
  openConfirmation: (title, body, variant, returnConfirmationResult) =>
    set({
      isOpen: true,
      title,
      body,
      variant,
      returnConfirmationResult,
    }),
  closeConfirmation: () => set({ isOpen: false, returnConfirmationResult: doNothing }),
}));
